import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { AppConstants } from '../constants/app-constants';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { RouteConstants } from '../constants/route-constants';
import { AlarmService } from '../services/alarm.service';

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
	public session: any;
	constructor(
		private authenticationService: AuthenticationService,
		public translate: TranslateService,
		private router: Router,
		public alarmService: AlarmService) { }

	ngOnInit() {
		this.redirectToDashboard();
		this.alarmService.startListeningToNewAlarms();
	}

	ngOnDestroy() { }

	/**
	 * Redirect to home after getting authenticated user details.
	 */
	redirectToDashboard() {
		const timeout = setInterval(() => {
			this.authenticationService.getUserSession().subscribe({
				next: (response) => {
					if (response[AppConstants.SUCCESS] === true) {
						this.session = response[AppConstants.SESSION];
						this.authenticationService.setSession(this.session);
						clearInterval(timeout);

						// Load same page on refresh/reload.
						if (this.router.url === (RouteConstants.PAGES + RouteConstants.HOME)) {
							this.router.navigate([RouteConstants.PAGES + RouteConstants.DASHBOARD], { skipLocationChange: false });
						}
						// If user is on a child route (like reports), stay on that route
						else if (this.router.url.startsWith(RouteConstants.PAGES + RouteConstants.HOME + '/')) {
							// Stay on current route - no navigation needed
							return;
						}
						else {
							// Fallback to dashboard for any other cases
							this.router.navigate([RouteConstants.PAGES + RouteConstants.DASHBOARD], { skipLocationChange: false });
						}
					}
				},
				error: (error) => {
					// error while getting auth user details.
				}
			});
		}, 100);
	}
}
